<router-outlet />
<main
	class="container"
	*ngIf="vm$ | async as vm"
	[ngClass]="{ 'container--sidenav-opened': menuOpened.sidenavOpened && !isMobile }"
>
	<button (click)="this.location.back()" class="back-button">
		<mat-icon svgIcon="porto-bank-icons:left-arrow"></mat-icon>
		Voltar
	</button>
	<h1 class="title">Reservas e Check-ins</h1>

	<section class="tab-container" *ngIf="!vm.loading">
		<div class="tab-buttons">
			<button [class.active]="selectedTab() === 'Ativos'" (click)="selectTab('Ativos')">Ativos</button>
			<button [class.active]="selectedTab() === 'Inativos'" (click)="selectTab('Inativos')">
				Inativos
			</button>
		</div>

		<ui-porto-bank-loading-page *ngIf="vm.loading"></ui-porto-bank-loading-page>

		<!-- Ativas -->
		<div class="tab-content" *ngIf="selectedTab() === 'Ativos'" [@slideIn]="selectedTab() === 'Ativos'">
			@for (order of vm.activeOrders; track order?.id) {
				<ng-container [ngTemplateOutlet]="orderCard" [ngTemplateOutletContext]="{ $implicit: order }">
				</ng-container>
			} @empty {
				<ng-container
					[ngTemplateOutlet]="notFoundOrder"
					[ngTemplateOutletContext]="{ $implicit: 'ativo' }"
				>
				</ng-container>
			}
		</div>

		<!-- Inativas -->
		<div
			class="tab-content"
			*ngIf="selectedTab() === 'Inativos'"
			[@slideIn]="selectedTab() === 'Inativos'"
		>
			@for (order of vm.inactiveOrders; track order?.id) {
				<ng-container [ngTemplateOutlet]="orderCard" [ngTemplateOutletContext]="{ $implicit: order }">
				</ng-container>
			} @empty {
				<ng-container
					[ngTemplateOutlet]="notFoundOrder"
					[ngTemplateOutletContext]="{ $implicit: 'realizado' }"
				>
				</ng-container>
			}
		</div>
	</section>

	<!-- Footer buttons -->
</main>

<ng-template #orderCard let-order>
	<article
		class="order-card"
		[class.checkin]="order.intent === 'CheckIn' && order.canPay && !order.isCanceled"
		(click)="selectOrder(order.id)"
	>
		<!-- Info -->
		<div style="display: flex; align-items: center; justify-content: space-between">
			<div class="order-card__details">
				<p class="order-card__intent">
					{{ getIntentLabel(order) }} • {{ order.reservationDateTime | date: 'HH:mm' }} •
					{{ order.reservationDateTime | date: 'dd/MM/yyyy' }}
				</p>
				<h2 class="order-card__name">{{ order.venue.name }}</h2>
				<p class="order-card__location">
					{{ order.venue.address.value }}
				</p>
			</div>

			<!-- View Details -->
			<div class="order-card__view-details">
				<mat-icon svgIcon="porto-bank-icons:right-arrow" (click)="selectOrder(order.id)"></mat-icon>
			</div>
		</div>
	</article>
</ng-template>

<ng-template #notFoundOrder let-type>
	<section style="display: flex; flex-direction: column; justify-content: center; align-items: center">
		<mat-icon
			svgIcon="porto-bank-icons:calendar"
			style="width: 36px; height: 34px; --icon-color: var(--content-primary)"
		>
		</mat-icon>
		<p
			style="
				font-size: 16px;
				font-weight: 600;
				margin-top: 16px;
				margin-bottom: 12px;
				text-align: center;
				color: var(--content-primary);
			"
		>
			Nenhuma reserva ou check-in encontrado
		</p>
		<p class="order-card__not-found">Explore os restaurantes e escolha sua próxima experiência.</p>
	</section>
</ng-template>
